import React, { useState, useMemo } from 'react';

import { useTranslation } from '@/i18n';
import PageLayout from '@/components/layout/PageLayout';
import { TabList } from '@/components/ui/navigation/TabList';
import ShiftsTab from './ShiftsTab';
import WorkingDaysTab from './WorkingDaysTab';


type WorkingDayTab = 'shifts' | 'workingDays';

export const ShiftList: React.FC = () => {
  const { t: translate } = useTranslation();
  const [activeTab, setActiveTab] = useState<WorkingDayTab>('shifts');

  const tabs = useMemo(
    () => [
      {
        id: 'shifts',
        label: translate('schedule:tabs.shifts'),
        content: <ShiftsTab />,
      },
      {
        id: 'workingDays',
        label: translate('schedule:tabs.workingDays'),
        content: <WorkingDaysTab />,
      },
    ],
    [translate],
  );

  return (
    <PageLayout>
      <div data-testid="working-days-page">
        <TabList
          tabs={tabs}
          defaultActiveTab={activeTab}
          onTabChange={(id) => setActiveTab(id as WorkingDayTab)}
        />
      </div>
    </PageLayout>
  );
};

export default ShiftList;
